import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, useMemo } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { useBreakpoint } from '@design-system/theme';
import { GAP_PADDING, GRID_PADDING, GRID_TEMPLATES } from './constants';
export const Section = ({ children, columnGap = GAP_PADDING, containerPaddingX = true, pb = 0, pt = 0, rowGap = GAP_PADDING, sectionFallback = null, }) => {
    const breakpoint = useBreakpoint();
    const childs = Array.isArray(children) ? children : [children];
    const gridTemplate = useMemo(() => GRID_TEMPLATES[breakpoint](childs === null || childs === void 0 ? void 0 : childs.length), [breakpoint, childs === null || childs === void 0 ? void 0 : childs.length]);
    return (_jsx(Suspense, { fallback: sectionFallback, children: _jsx(StyledSection, { "$containerPaddingX": containerPaddingX, "data-testid": "section", pb: pb, pt: pt, children: _jsx(FluidGrid, { "$columnGap": columnGap, "$gridTemplateColumns": gridTemplate, "$rowGap": rowGap, children: children }) }) }));
};
const StyledSection = styled(Box).attrs(({ $containerPaddingX }) => ({
    px: $containerPaddingX ? GRID_PADDING : undefined,
    width: '100%',
})) ``;
const FluidGrid = styled(Box) `
  display: grid;
  grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
  width: 100%;
  column-gap: ${({ $columnGap }) => $columnGap};
  row-gap: ${({ $rowGap }) => $rowGap};
`;
//# sourceMappingURL=Section.js.map